// import feature state here
import { provideState } from '@ngrx/store';
import { EnvironmentProviders } from '@angular/core';
import { irGeneratorFeature } from '@ps/ai-assistant-data-access';
import { AUTH_STORE_PROVIDERS } from '@ps/auth-data-access';
import { SOCKET_STORE_PROVIDERS } from '@ps/core-data-access';
import { SURVEY_STORE_PROVIDERS } from '@ps/survey-data-access';
import { SURVEY_CREATION_STORE_PROVIDERS } from '@ps/survey-creation-data-access';
import { SURVEY_MANAGEMENT_STORE_PROVIDERS } from '@ps/survey-management-data-access';
import { TEMPLATE_STORE_PROVIDERS } from '@ps/survey-template-data-access';
import { supplierFeature } from '@ps/supplier-data-access';
import { companyFeature } from '@ps/company-data-access';
import { questionFeature } from '@ps/question-data-access';
import { invoiceFeature } from '@ps/invoice-data-access';
import { REPORT_STORE_PROVIDERS } from '@ps/report-data-access';
import { buyerFeature, decipherMappingFeature } from '@ps/buyers-data-access';
import { USER_SETTINGS_STORE_PROVIDERS } from '@ps/user-settings-data-access';
import { TAGS_STORE_PROVIDERS } from '@ps/tags-data-access';
import { NOTIFICATION_STORE_PROVIDERS } from '@ps/notification-data-access';
import {
  companyMarginsFeature,
  coreMappingsFeature,
  externalBuyerMappingsFeature,
  operatorCompaniesFeature,
  operatorSettingsFeature,
} from '@ps/platform-setting-data-access';

export const STORE_FEATURES: EnvironmentProviders[] = [
  AUTH_STORE_PROVIDERS.feature,
  SOCKET_STORE_PROVIDERS.feature,
  SURVEY_STORE_PROVIDERS.feature,
  SURVEY_CREATION_STORE_PROVIDERS.feature,
  SURVEY_MANAGEMENT_STORE_PROVIDERS.feature,
  TEMPLATE_STORE_PROVIDERS.feature,
  REPORT_STORE_PROVIDERS.feature,
  provideState(irGeneratorFeature),
  provideState(supplierFeature),
  provideState(companyFeature),
  provideState(questionFeature),
  provideState(invoiceFeature),
  provideState(buyerFeature),
  provideState(decipherMappingFeature),
  provideState(operatorSettingsFeature),
  provideState(externalBuyerMappingsFeature),
  provideState(coreMappingsFeature),
  provideState(companyMarginsFeature),
  provideState(operatorCompaniesFeature),
  USER_SETTINGS_STORE_PROVIDERS.feature,
  TAGS_STORE_PROVIDERS.feature,
  NOTIFICATION_STORE_PROVIDERS.feature,
];
